import React, { Component } from 'react';
import { node, object } from 'prop-types';
import { parseString } from 'xml2js';

import { AuthContext, withAuth } from '../auth';

export const ConfigureOneContext = React.createContext();

class ConfigureOneProvider extends Component {
  static contextType = AuthContext;

  state = {
    c1Link: null
  };

  // If there is a new user fetch C1 Link
  componentDidUpdate(prevProps) {
    if (
      process.env.REACT_APP_C1_ENABLED === 'true' &&
      Object.entries(prevProps.authUser).length === 0 &&
      Object.entries(this.props.authUser).length > 0
    ) {
      this.fetchC1Link();
    }
  }

  fetchC1Link = async () => {
    try {
      const { authUser } = this.props;
      const { email } = authUser;

      // Fetch C1 link.
      const response = await fetch(
        `https://fusion.aggrowth.com:8081/configureOneByEmailAddress?emailaddress=${email}&c1environment=${
          process.env.REACT_APP_C1_ENVIRONMENT
        }&token=${process.env.REACT_APP_C1_TOKEN}`
      );

      const xmlText = await response.text();

      // API returns a 200 even if invalid user. If the data doesn't include error = happy path.
      // Otherwise set c1Link to false to hide display.
      if (!xmlText.includes('error')) {
        parseString(xmlText, (err, result) => {
          this.setState({ c1Link: result.c1TokenUrl });
        });
      } else {
        this.setState({ c1Link: false });
      }
    } catch (e) {
      // fail silently
    }
  };

  render() {
    const { c1Link } = this.state;
    const { children } = this.props;

    return (
      <ConfigureOneContext.Provider value={{ c1Link }}>
        {children}
      </ConfigureOneContext.Provider>
    );
  }
}

ConfigureOneProvider.propTypes = {
  children: node.isRequired,
  authUser: object
};

export default withAuth(ConfigureOneProvider);



// WEBPACK FOOTER //
// ./src/contexts/configureOne.js